/* RESPONSIBLE TEAM: team-automation-foundations */
import Model, { attr } from '@ember-data/model';

export default class AutomationEmailSettings extends Model {
  @attr('boolean') declare suppressCcForBotReplies: boolean;
}
